import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Icon, SlimButtonComponent } from '@web/shared/ui';
import { Route, RouterLinkComponent } from '@web/common';

@Component({
  selector: 'app-public-cart-empty',
  imports: [RouterLinkComponent, SlimButtonComponent],
  templateUrl: './public-cart-empty.component.html',
  styleUrl: './public-cart-empty.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicCartEmptyComponent {
  protected readonly Icon = Icon;
  protected readonly Route = Route;
}
